import { useContext } from 'react'
import { utils } from '@digital-commerce/shared-utils'
import { object } from 'prop-types'

import localeContext from '../../../contexts/Locale'
import useTranslate from '../../../hooks/useTranslate'

import PriceBreakdownContainer from '../../molecules/CartItem/PriceBreakdown/PriceBreakdownContainer'
import {
  FinalPrice,
  ItemsPrice,
  OtherChargesAndCreditsContainer
} from '../../molecules/CartItem/PriceBreakdown'
import {
  buildCallingFeaturesList,
  buildHomePhoneAddonsList,
  buildAdditionalFeesList,
  buildRecurringDiscountList,
  buildDiscountsAndCreditsList
} from './utils'
import HeadingWithSubItems from '../../molecules/CartItem/PriceBreakdown/HeadingWithSubItems'
import NameAndPrice from '../../atoms/ItemDetails/NameAndPrice'
import { isAffiliateCampaign } from '../../../utils/cart'

const {
  cart: { getMonthlyTotalPrice }
} = utils

const OfferDetails = ({ homePhone, cart }) => {
  const translate = useTranslate()
  const { lang } = useContext(localeContext)
  const monthlyTotalPrice = getMonthlyTotalPrice(homePhone)?.subTotal
  const isAffiliates = isAffiliateCampaign(cart)

  const callingFeaturesData = buildCallingFeaturesList(homePhone, lang)
  const addonsData = buildHomePhoneAddonsList(homePhone, lang)
  const additionalFeesData = buildAdditionalFeesList(homePhone, lang)
  const recurringDiscountData = buildRecurringDiscountList(homePhone, lang, translate, isAffiliates)
  const discountsAndCreditsData = buildDiscountsAndCreditsList(homePhone, cart, lang)

  const callingFeatures = (
    <HeadingWithSubItems
      headingText={translate('callingFeatures')}
      subItems={callingFeaturesData}
    />
  )

  const addons = <HeadingWithSubItems headingText={translate('addon')} subItems={addonsData} />

  const additionalFees = (
    <HeadingWithSubItems headingText={translate('additionalFees')} subItems={additionalFeesData} />
  )

  const recurringDiscounts = recurringDiscountData.map((discount) => (
    <NameAndPrice
      id={discount.id}
      key={discount.id}
      name={discount.name}
      price={discount.price}
      prefixIcon={discount.prefixIcon}
    />
  ))

  const discountsAndCredits = (
    <HeadingWithSubItems
      headingText={translate('additionalChargesAndCredits.additionalCreditsAndDiscounts')}
      subItems={discountsAndCreditsData}
    />
  )

  return (
    <>
      <PriceBreakdownContainer>
        <ItemsPrice items={[homePhone]} isRecurring />
        {callingFeatures}
        {addons}
        {additionalFees}
        {recurringDiscounts}
        <FinalPrice price={monthlyTotalPrice} isMonthly />
      </PriceBreakdownContainer>
      <OtherChargesAndCreditsContainer listData={discountsAndCreditsData}>
        {discountsAndCredits}
      </OtherChargesAndCreditsContainer>
    </>
  )
}

export default OfferDetails

OfferDetails.propTypes = {
  homePhone: object.isRequired,
  cart: object.isRequired
}
